module.exports = __webpack_public_path__ + "static/jamie-2d9a92e217f8f512feea8e5a33be5749.png";